var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58353 0C6.66041 0 6.73414 0.0305382 6.78849 0.0848965L8.42816 1.72456C8.54136 1.83776 8.54136 2.02129 8.42816 2.13448L3.09924 7.4634C3.06282 7.49982 3.01736 7.52587 2.96754 7.53889L0.748158 8.1186C0.648596 8.1446 0.542709 8.11588 0.469946 8.04311C0.397183 7.97035 0.368453 7.86446 0.394458 7.7649L0.974169 5.54552C0.987184 5.49569 1.01324 5.45023 1.04966 5.41382L6.37858 0.0848965C6.43293 0.0305382 6.50666 0 6.58353 0Z",
    fill: "#EB6424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.434783 9.13043C0.194659 9.13043 0 9.32509 0 9.56522C0 9.80534 0.194659 10 0.434783 10H9.13043C9.37056 10 9.56522 9.80534 9.56522 9.56522C9.56522 9.32509 9.37056 9.13043 9.13043 9.13043H0.434783Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.270a9b059ca814400c065e065c5e2ab1.svg";
export { ForwardRef as ReactComponent };